import { render, staticRenderFns } from "./compClinicComboBox.vue?vue&type=template&id=af0d3686&scoped=true"
import script from "./compClinicComboBox.vue?vue&type=script&lang=js"
export * from "./compClinicComboBox.vue?vue&type=script&lang=js"
import style0 from "./compClinicComboBox.vue?vue&type=style&index=0&id=af0d3686&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af0d3686",
  null
  
)

export default component.exports